<template>
    <footer class="footer-wrapper pt-50 pb-40">
        <div class="container">
            <div class="footer-content text-center">
                <newsletter />

                <ul class="d-flex align-center justify-center mb-15 gap-7">
                    <li><router-link to="/contact">Get In Touch</router-link></li> |
                    <li><a href="tel:+4848287742">+484 828 (7424)</a></li>
                </ul>

                <ul class="terms-condition d-flex align-center justify-center mb-10 gap-7">
                    <li><router-link to="">Terms &amp; Conditions</router-link></li> |
                    <li><router-link to="">Faq</router-link></li> |
                    <li><router-link to="">Privacy Policy</router-link></li>
                </ul>
                <p class="copyright mt-30">
                    &copy; 2022 <b>Onepost</b>. Design by <b>ThemeOnFire</b>
                </p>
            </div>
        </div>
    </footer>
</template>

<script>
import Newsletter from '../Modules/Newsletter.vue';

export default {
    name: 'ThemeFooter',
    components: {
        Newsletter
    }
}
</script>